import type { FC, SVGAttributes } from 'react';

const SaleTag04: FC<SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg
      {...props}
      width='29'
      height='19'
      viewBox='0 0 29 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect y='0.5' width='29' height='18' rx='5.5' fill='#FF4C52' />
      <path
        d='M9.39516 15C8.78142 15 8.20728 14.8854 7.67273 14.6562C7.13819 14.4171 6.67293 14.0684 6.27697 13.6101C5.88101 13.1418 5.56919 12.5639 5.34152 11.8764C5.11384 11.1889 5 10.3918 5 9.48505C5 8.57835 5.11384 7.78125 5.34152 7.09375C5.56919 6.40625 5.88101 5.83333 6.27697 5.375C6.67293 4.91667 7.13819 4.57292 7.67273 4.34375C8.20728 4.11458 8.78142 4 9.39516 4C10.0089 4 10.583 4.11458 11.1176 4.34375C11.6521 4.57292 12.1174 4.91667 12.5133 5.375C12.9093 5.82337 13.2211 6.3913 13.4488 7.0788C13.6765 7.75634 13.7903 8.54846 13.7903 9.45516C13.7903 10.3619 13.6765 11.159 13.4488 11.8465C13.2211 12.534 12.9093 13.1119 12.5133 13.5802C12.1174 14.0485 11.6521 14.4022 11.1176 14.6413C10.583 14.8804 10.0089 15 9.39516 15ZM9.38031 13.5054C9.73668 13.5054 10.0683 13.4357 10.3752 13.2962C10.6919 13.1467 10.9592 12.9176 11.177 12.6087C11.4047 12.2899 11.5828 11.8764 11.7115 11.3682C11.8402 10.8601 11.9046 10.2373 11.9046 9.5C11.9046 8.77264 11.8402 8.15489 11.7115 7.64674C11.5828 7.12862 11.4047 6.71513 11.177 6.40625C10.9592 6.08741 10.6969 5.85824 10.39 5.71875C10.0831 5.56929 9.75153 5.49456 9.39516 5.49456C9.0388 5.49456 8.70718 5.56929 8.40031 5.71875C8.09344 5.85824 7.82617 6.08741 7.59849 6.40625C7.37081 6.71513 7.19263 7.12862 7.06394 7.64674C6.93526 8.15489 6.87091 8.77264 6.87091 9.5C6.87091 10.2373 6.93526 10.8601 7.06394 11.3682C7.19263 11.8764 7.37081 12.2899 7.59849 12.6087C7.82617 12.9176 8.09344 13.1467 8.40031 13.2962C8.70718 13.4357 9.03385 13.5054 9.38031 13.5054Z'
        fill='white'
        fillOpacity='0.98'
      />
      <path
        d='M20.867 6.25679L17.7042 10.9497H20.867V6.25679ZM22.6636 12.4443V14.8505H20.867V12.4443H15.9373V11.0992L20.6442 4.14946H22.6636V10.9497H24V12.4443H22.6636Z'
        fill='white'
        fillOpacity='0.98'
      />
    </svg>
  );
};

export default SaleTag04;
